import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import InfoGroup from '../InfoGroup/InfoGroup';
import api from '../../Api/api';
import TabButtons from '../TabButtons/TabButtons';
import {
  REQUEST_GET_USER_DATA_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_FOR_ADMIN,
} from '../../Redux/constants/constants';

const UserOverviewTab = ({ data, isEditing }) => {
  const [editing, setEditing] = useState(isEditing);
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    setLocalData(data);
    if (data.newUser === true) {
      setEditing(true);
    } else {
      setEditing(false);
    }
  }, [data]);

  const handleClick = (value) => {
    if (value === 'save') {
      setLoading(true);
      api
        .postUserData({
          id: localData.id,
          name: localData.name,
          role: localData.role,
          email: localData.email,
          leaveAmount: localData.leaveAmount,
          hourlyWage: localData.hourlyWage,
          status: localData.status,
        })
        .then((res) => {
          setEditing(false);
          setLoading(false);
          dispatch({
            type: REQUEST_GET_USER_DATA_FOR_ADMIN,
            payload: res.data.id,
          });
          dispatch({ type: REQUEST_GET_ALL_USERS_FOR_ADMIN });
        })
        .catch(() => {
          setEditing(false);
          setLoading(false);
          console.log('some error during save');
        });
    }
    if (value === 'edit') setEditing(true);
    if (value === 'cancel') setEditing(false);
  };

  const onChange = (value, key) => {
    setLocalData({ ...localData, [key]: value });
  };

  return (
    <>
      <InfoGroup
        editable
        type={'text'}
        text={'Imię i Nazwisko'}
        placeHolder={'Imię i Nazwisko'}
        data={localData.name}
        editing={editing}
        onChange={onChange}
        id={'name'}
      />
      <InfoGroup
        editable
        type={'role-drop-down'}
        text={'Rola'}
        placeHolder={'Rola'}
        data={localData.role}
        editing={editing}
        id={'role'}
        onChange={onChange}
      />
      <InfoGroup
        editable
        type={'text'}
        text={'Email pracownika'}
        placeHolder={'Email pracownika'}
        data={localData.email}
        editing={editing}
        onChange={onChange}
        id={'email'}
      />
      <InfoGroup
        editable
        type={'currency'}
        text={'Stawka godzinowa'}
        placeHolder={'Stawka godzinowa'}
        data={localData.hourlyWage}
        editing={editing}
        onChange={onChange}
        id={'hourlyWage'}
      />
      <InfoGroup
        editable
        type={'number'}
        text={'Ilość urlopu'}
        placeHolder={'Ilość dni urlopu wypoczynkowego'}
        data={localData.leaveAmount}
        editing={editing}
        onChange={onChange}
        id={'leaveAmount'}
      />
      <InfoGroup
        type={'number'}
        text={'Wykorzystane dni urlopowe'}
        placeHolder={'Wykorzystane dni urlopowe'}
        data={localData.sumVacationDays}
        // editing={editing}
        onChange={onChange}
        id={'usedPaidLeave'}
      />
      <InfoGroup
        type={'number'}
        text={'Wykorzystane dni urlopowe w zeszłym roku'}
        placeHolder={'Wykorzystane dni urlopowe w zeszłym roku'}
        data={localData.sumVacationDaysForPrevYear}
        // editing={editing}
        onChange={onChange}
        id={'usedPaidLeaveForPrevYear'}
      />
      <InfoGroup
        type={'number'}
        text={'Ilość zasiłku chorobowego'}
        placeHolder={'Numer projektu'}
        data={localData.sumSickLeaveDays}
        // editing={editing}
        onChange={onChange}
        id={'usedSickLeave'}
      />
      <InfoGroup
        type={'number'}
        text={'Ilość dostępnych nadgodzin'}
        placeHolder={'Ilość dostępnych nadgodzin'}
        data={localData.availableOvertime}
        id={'availableOvertime'}
      />
      <InfoGroup
        type={'number'}
        text={'Dni wolne z nadgodzin'}
        placeHolder={'Wykorzystane dni wolne z nadgodzin'}
        data={localData.sumUsedOvertimeDays}
        id={'sumUsedOvertimeDays'}
      />
      {/* <InfoGroup
        type={'text'}
        text={'Resend invitation'}
        placeHolder={'Numer projektu'}
        data={localData.number}
        editing={editing}
        onChange={onChange}
        id={'number'}
      /> */}
      <InfoGroup
        editable
        type={'status-drop-down'}
        text={'Status'}
        placeHolder={'Status'}
        data={localData.status}
        editing={editing}
        id={'status'}
        onChange={onChange}
      />
      <TabButtons
        inUserOverviewTab
        editing={editing}
        handleClick={handleClick}
        loading={loading}
        isProjectLoaded={localData.id}
      />
    </>
  );
};

export default UserOverviewTab;
